/* import __COLOCATED_TEMPLATE__ from './unified-content.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface Signature {
  Args: {
    finIsLive: boolean;
    openSectionId?: string;
    setOpenSectionId: (sectionId: string) => void;
    showPreview: boolean;
    togglePreview: () => void;
  };
  Blocks: {
    default: [];
  };
}

/**
 * The unified content interface component that contains all the new UI logic.
 * This component is only rendered when the feature flag is enabled.
 */
export default class UnifiedContent extends Component<Signature> {
  @service declare appService: $TSFixMe;

  // Preview state management
  @tracked previewLocale = 'en';
  @tracked previewMode: 'agent' | 'copilot' = 'agent';

  constructor(owner: unknown, args: any) {
    super(owner, args);

    // Initialize preview locale based on app settings
    this.previewLocale = this.appService.app.locale || 'en';
    if (this.appService.app.canUseFinPreviewAutoLanguageDetection) {
      this.previewLocale = 'auto';
    }
  }

  @action
  setPreviewLocale(locale: string) {
    this.previewLocale = locale;
  }

  @action
  setPreviewMode(mode: 'agent' | 'copilot') {
    this.previewMode = mode;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::UnifiedContent': typeof UnifiedContent;
    'fin-ai-agent/knowledge/unified-content': typeof UnifiedContent;
  }
}
